import {
  Component,
  TemplateRef,
  Input,
  ElementRef,
  Renderer2,
  OnChanges,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toNumber } from '../util';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'number-info',
  template: `
  <div *ngIf="_title || _titleTpl" class="title"><ng-container *ngIf="_title; else _titleTpl">{{_title}}</ng-container></div>
  <div *ngIf="_subTitle || _subTitleTpl" class="sub-title">
  <ng-container *ngIf="_subTitle; else _subTitleTpl">{{_subTitle}}</ng-container></div>
  <div class="value" [ngStyle]="{'margin-top.px': gap}">
    <span><ng-container *ngIf="_total; else _totalTpl">{{_total}}</ng-container><em class="suffix" *ngIf="suffix">{{suffix}}</em></span>
    <span *ngIf="status || _isSubTotal" class="sub-total">
      <ng-container *ngIf="_subTotal; else _subTotalTpl">{{_subTotal}}</ng-container>
      <i *ngIf="status" class="anticon anticon-caret-{{status}}" nz-icon></i>
    </span>
  </div>
  `,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberInfoComponent implements OnChanges {
  _title = '';
  _titleTpl: TemplateRef<any>;
  /** æ é¢ */
  @Input()
  set title(value: string | TemplateRef<any>) {
    if (value instanceof TemplateRef) {
      this._title = null;
      this._titleTpl = value;
    } else { this._title = value; }
  }

  _subTitle = '';
  _subTitleTpl: TemplateRef<any>;
  /** å­æ é¢ */
  @Input()
  set subTitle(value: string | TemplateRef<any>) {
    if (value instanceof TemplateRef) {
      this._subTitle = null;
      this._subTitleTpl = value;
    } else { this._subTitle = value; }
  }

  _total = '';
  _totalTpl: TemplateRef<any>;
  /** æ»é */
  @Input()
  set total(value: string | TemplateRef<any>) {
    if (value instanceof TemplateRef) {
      this._total = null;
      this._totalTpl = value;
    } else { this._total = '' + value; }
  }

  _isSubTotal = false;
  _subTotal = '';
  _subTotalTpl: TemplateRef<any>;
  /** æ»éåç¼ */
  @Input()
  set subTotal(value: string | TemplateRef<any>) {
    if (value instanceof TemplateRef) {
      this._subTotal = null;
      this._subTotalTpl = value;
    } else { this._subTotal = value; }

    this._isSubTotal = !!value;
  }

  /** å­æ»é */
  @Input() suffix: string;

  /** å¢å ç¶æ */
  @Input() status: 'up' | 'down';

  /** ç¶ææ ·å¼ */
  @Input() theme: 'light' | '' = 'light';

  /** è®¾ç½®æ°å­åæè¿°ç´æ¥çé´è·ï¼åç´ ï¼ */
  @Input()
  get gap() {
    return this._gap;
  }
  set gap(value: any) {
    this._gap = toNumber(value);
  }
  private _gap = 8;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
  ) {}

  _classMap: string[] = [];
  setClass() {
    this._classMap.forEach(cls =>
      this.renderer.removeClass(this.el.nativeElement, cls),
    );
    this._classMap = ['ad-number-info'];
    if (this.theme) { this._classMap.push(this.theme); }
    this._classMap.forEach(cls =>
      this.renderer.addClass(this.el.nativeElement, cls),
    );
    this.cd.detectChanges();
  }

  ngOnChanges(): void {
    this.setClass();
  }
}
